// hooks/usePermissions.ts
import { useAuth } from '../context/AuthContext';
import {
  UserRole,
  isAdmin,
  isOperation,
  isVendor,
  canAddVendor,
  canAssociateQRCode,
  canGenerateQRCode,
  canAddUsers,
  canAccessAdminDashboard,
  hasRole,
  hasAnyRole,
  getUserHighestRole,
  getUserRoles,
  canDeleteVendor,
  canConfirmVendor,
  canManagePricing,
  canViewPricing,
  canViewAnalytics,
  canManageProductCategories,
  canViewProductCategories,
  canDeleteProductCategories,
  canPlaceOrders,
  canViewQrCodeDashboard
} from '../config/rbac';

export const usePermissions = () => {
  const { user, isAuthenticated } = useAuth();

  return {
    // Authentication state
    isAuthenticated,
    user,
    
    // Role checks
    isAdmin: isAdmin(user),
    isOperation: isOperation(user),
    isVendor: isVendor(user),
    
    // Permission checks
    canAddVendor: canAddVendor(user),
    canAssociateQRCode: canAssociateQRCode(user),
    canGenerateQRCode: canGenerateQRCode(user),
    canAddUsers: canAddUsers(user),
    canAccessAdminDashboard: canAccessAdminDashboard(user),
    canDeleteVendor: canDeleteVendor(user),
    canConfirmVendor: canConfirmVendor(user),
    canManagePricing: canManagePricing(user),
    canViewPricing: canViewPricing(user),
    canViewAnalytics: canViewAnalytics(user),
    canManageProductCategories: canManageProductCategories(user),
    canViewProductCategories: canViewProductCategories(user),
    canDeleteProductCategories: canDeleteProductCategories(user),
    canPlaceOrders: canPlaceOrders(user),
    canViewQrCodeDashboard: canViewQrCodeDashboard(user),

    // Utility functions
    hasRole: (role: UserRole) => hasRole(user, role),
    hasAnyRole: (roles: UserRole[]) => hasAnyRole(user, roles),
    getUserHighestRole: () => getUserHighestRole(user),
    getUserRoles: () => getUserRoles(user),
  };
};